import { type InferOutput, nullish, object, record, string } from "valibot"

export const flowStagesResponseSchema = object({
  currentStage: string(),
  previousStage: nullish(string()),
})
export type FlowStagesResponse = InferOutput<typeof flowStagesResponseSchema>

export const flowStagesRequestSchema = object({
  currentStage: string(),
  metadata: nullish(record(string(), string())),
})
export type FlowStagesRequest = InferOutput<typeof flowStagesRequestSchema>
